import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { StyledImage } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';
import { BLOCK_MAPPING } from '../../constants/blocks.js';
import BlocksContext from './BlockContext.js';

var BlockListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-rwneio-0"
})(["", "{max-width:100%;height:auto;}"], StyledImage);
var BlockList = function BlockList(_ref) {
  var blocks = _ref.blocks;
  return /*#__PURE__*/React.createElement(BlocksContext.Provider, {
    value: {
      rootBlocks: blocks
    }
  }, /*#__PURE__*/React.createElement(BlockListWrapper, null, blocks.map(function (block, index) {
    if (BLOCK_MAPPING[block.blockName]) {
      var Block = BLOCK_MAPPING[block.blockName];
      var Component = Block !== null && Block !== void 0 && Block.Component ? Block.Component : Block;
      return /*#__PURE__*/React.createElement(Component, _extends({
        key: String(index)
      }, block));
    }
    return null;
  })));
};

// TODO: transition all blocks to use this instead since the above
//  creates an extra parent which messes with certain blocks like Accordion.
var generateBlockList = function generateBlockList(_ref2) {
  var _ref2$blocks = _ref2.blocks,
    blocks = _ref2$blocks === void 0 ? [] : _ref2$blocks;
  return blocks.map(function (block, index) {
    if (BLOCK_MAPPING[block.blockName]) {
      var Block = BLOCK_MAPPING[block.blockName];
      var Component = Block !== null && Block !== void 0 && Block.Component ? Block.Component : Block;
      return /*#__PURE__*/React.createElement(Component, _extends({
        key: String(index)
      }, block));
    }
    return null;
  });
};
var BlockList$1 = BlockList;

export { BlockList$1 as default, generateBlockList };
